export const countryQuery = `country=${process.env.REACT_APP_ENV_COUNTRY}`;
